import * as Yup from 'yup';
import { emailRequired, nameRequired } from '.';

export const addCompanySchema = Yup.object({
    company_name: nameRequired,
    email: emailRequired
});

export const addProjectSchema = Yup.object({
    project_name: nameRequired,
    email: emailRequired
    // assignees: Yup.array()
    //     .min(1, 'At least one team member is required')
    //     .of(Yup.number().required('Invalid team member selection'))
});